export default "__VITE_ASSET__Dzrmz9lJ__"